import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
  TelegramIcon,
  TelegramShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  EmailIcon,
  EmailShareButton,
} from 'react-share'
import * as React from 'react'
import { Typography } from '@mui/material'
import CopyComponent from '../CopyComponent'

const ShareSocialComponent = (props: {
  url: string
  title: string
  label: string
  shareUrlStyle?: React.CSSProperties
  copyIconStyle?: React.CSSProperties
  labelStyle?: React.CSSProperties
}) => {
  const { title, label } = props
  const shareUrl = props.url
  //   const title = "Register for " + this.state.course_name + " class";
  return (
    <>
      <Typography
        variant="body2"
        style={{ color: '#fafafaab', ...props.labelStyle }}
      >
        <span>{label}</span>
      </Typography>
      {/* <div style={{ display: "flex", flexWrap: "wrap", width: "100%" }}> */}
      <div style={{ overflowX: 'auto' }}>
        <Typography
          onClick={e => {
            e?.preventDefault()
            e?.stopPropagation()
          }}
          variant="h6"
          style={{ wordBreak: 'break-word' }}
        >
          <a
            style={{ textDecoration: 'none', ...props.shareUrlStyle }}
            target="_blank"
            href={shareUrl}
          >
            {shareUrl}
          </a>
          <CopyComponent
            iconStyle={{ ...props.copyIconStyle }}
            text={shareUrl}
            iconButtonProps={{ size: 'large' }}
          />
        </Typography>
      </div>
      {/* </div> */}
      <div style={{ display: 'inline-flex', cursor: 'pointer' }}>
        <FacebookShareButton
          style={{ margin: '0px 2px' }}
          url={shareUrl}
          quote={title}
        >
          <FacebookIcon size={32} round />
        </FacebookShareButton>
        <LinkedinShareButton
          style={{ margin: '0px 2px' }}
          url={shareUrl}
          title={title}
          quote={title}
        >
          <LinkedinIcon size={32} round />
        </LinkedinShareButton>
        <TwitterShareButton
          style={{ margin: '0px 2px' }}
          url={shareUrl}
          title={title}
          quote={title}
        >
          <TwitterIcon size={32} round />
        </TwitterShareButton>
        <WhatsappShareButton
          style={{ margin: '0px 2px' }}
          url={shareUrl}
          title={title}
          quote={title}
        >
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>
        <TelegramShareButton
          style={{ margin: '0px 2px' }}
          url={shareUrl}
          title={title}
          quote={title}
        >
          <TelegramIcon size={32} round />
        </TelegramShareButton>
        <EmailShareButton
          style={{ margin: '0px 2px' }}
          url={shareUrl}
          subject={title}
          body={title}
        >
          <EmailIcon size={32} round />
        </EmailShareButton>
      </div>
    </>
  )
}

export default ShareSocialComponent
